import { matchRoutes, useLocation } from "react-router-dom"

const routes = [
  { path: "/login" },
  { path: "/register" },
  { path: "/rooms/new" },
  { path: "/rooms/:id" },
  { path: "/rooms" },
  { path: "/settings" },
  { path: "/rooms/:id/invite" },
  { path: "/rooms/:id/leave" },
]

export const useCurrentPath = () => {
  const location = useLocation()
  const matching_routes = matchRoutes(routes, location)
  if (matching_routes === null) {
    return 'fndogwghwrgdfg8493/w4tw4t93'
  }
  return matching_routes[0].route.path
}
